import {
  createI18nInstance,
  createLocaleProvider,
  defaultNS,
  getUseLocoTranslation,
} from '@systemeio/util'
import enCommon from './assets/locales/en/translation.json'
import { LanguageCodeEnum } from '@systemeio/types'
import { useContext } from 'react'
import { useTranslation as useTranslationReact } from 'react-i18next'

const preloadedResources = {
  en: {
    [defaultNS]: enCommon,
  },
}

const { i18n } = createI18nInstance({
  debug: process.env.APP_ENV === 'development',
  resources: preloadedResources,
})

const loadLangBundle = (locale: LanguageCodeEnum) =>
  import(`./assets/locales/${locale}/translation.json`).then(mod => mod.default)

const { LocaleContext, LocaleProvider } = createLocaleProvider()

const defaultNamespaces = [defaultNS]
const namespaceMapper = () => defaultNamespaces

const useTranslation = getUseLocoTranslation({
  useTranslation: (ns, options) => {
    const { i18n } = useContext(LocaleContext) ?? {}

    return useTranslationReact(ns, {
      i18n,
      ...options,
    })
  },
  defaultNamespaces,
  namespaceMapper,
})

export { i18n, LocaleContext, LocaleProvider, loadLangBundle, useTranslation }
